import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const batchSummaryStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: "10px 0px 0px 25px",
        },
        title: {
            fontWeight: 600,
            fontSize: "18px",
            marginBottom: "15px",
        },
        decision: {
            marginTop: "10px",
        },
    })
);
